import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import SignatureCanvas from 'react-signature-canvas';

const SignatureDialog = ({ open, onClose, onSave, signaturePadRef }) => {
  const handleClear = () => {
    if (signaturePadRef.current) {
      signaturePadRef.current.clear();
    }
  };

  const handleSave = () => {
    if (signaturePadRef.current && !signaturePadRef.current.isEmpty()) {
      const dataURL = signaturePadRef.current.toDataURL();
      onSave(dataURL);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ backgroundColor: '#008080', color: 'white' }}>
        Provide Digital Signature
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Box sx={{ border: '1px dashed #ccc', borderRadius: 1, overflow: 'hidden' }}>
          <SignatureCanvas
            ref={signaturePadRef}
            penColor="black"
            canvasProps={{
              width: 550,
              height: 200,
              className: 'signature-canvas',
              style: { width: '100%', height: '200px' }
            }}
          />
        </Box>
        <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
          Please sign within the box above
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClear}>Clear</Button>
        <Button onClick={onClose} color="error">Cancel</Button>
        <Button onClick={handleSave} variant="contained" sx={{ backgroundColor: '#008080' }}>
          Save Signature
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignatureDialog;
